<template>
    <header id="navbar">
        <div id="navbar-container" class="boxed">
            <div class="navbar-header">
                <a href="/admin/" class="navbar-brand">
                    <div class="brand-title">
                        <span class="brand-text">Ambassador</span>
                    </div>
                    <img src="/images/ship.png" class="ship-icon"/>
                </a>
            </div>

            <div class="navbar-content clearfix">

                <ul class="nav navbar-top-links pull-left">
                    <li class="tgl-menu-btn">
                        <a class="mainnav-toggle" @click.prevent="toggle" id="mainnav-toggle" href="#" title="Hide menu">
                            <i class="fa fa-navicon text-dark"></i>
                        </a>
                    </li>
                    <li class="dropdown"></li>
                    <li class="megadropdown"></li>
                </ul>

                <ul class="nav navbar-top-links pull-right">
                    <li id="dropdown-user" class="dropdown">
                        <a href="" @click.prevent="menuVisible = !menuVisible" class="dropdown-toggle text-right" aria-expanded="true">
									<span class="ic-user pull-right">
										<i class="pli-male"></i>
									</span>
                            <div class="username hidden-xs">{{ $store.getters['auth/getUserName'] }}</div>
                        </a>


                        <div v-if="menuVisible" class="dropdown-menu dropdown-menu-md dropdown-menu-right panel-default" style="opacity: 1; display: block">
                            <!-- User dropdown menu -->
                            <ul class="head-list">
                                <li>
                                    <!--<a href="#">-->
                                    <!--<i class="pli-male icon-lg icon-fw"></i> Profile-->
                                    <!--</a>-->
                                </li>
                                <li>
                                    <a href="#" @click.prevent="logout">
                                        <i class="pli-unlock"></i> Logout
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>


        </div>
    </header>
</template>

<script>
    // Top navigation bar component
    export default {
        name: "TopBar",
        data() {
            return {
                menuVisible: false,
            }
        },
        methods: {
            // @vuese
            // Logout of wave
            async logout() {
                await this.$store.dispatch('auth/logout');
                localStorage.clear();
                window.location.href = '/login';
            },

            // @vuese
            // Toggle the sidebar
            toggle(event) {
                this.$store.commit('sidebar/toggle');
                return false;
            },


        }
    }
</script>

<style scoped>
.ship-icon {
    max-width:30px;
    margin-left:10px;
    margin-top:10px
}

#navbar {
    position: fixed;
}
</style>
